import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  ChevronDown,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';
import {
  ChartPieSolid,
  ProspectsSolid,
  FileChartBarSolid,
  FileCheckSolid,
  UserPlusSolid,
  UsersSolid,
  ArchiveSolid,
  CashSolid,
  ClipboardListSolid,
  SignatureSolid,
  ComputerSolid,
  GanttSolid,
  InduccionSolid,
  TesoreriaIcon,
  GestionViaticosIcon
} from '../Icons/FlowbiteIcons';

export const menuGroups = [
  {
    title: "Dashboard",
    icon: ChartPieSolid,
    items: [
      { to: "/grafico_dashboard", label: "Gerencial", allowed: [8, 6, 10, 9, 20, 1, 26] },
      // { to: "/dashboard_administracion", label: "Administrativo", allowed: [8, 5] },
      { to: "/reporte_colaboradores", label: "Colaboradores", allowed: [8, 5, 22, 9, 26] },
      // { to: "/graficos_colocaciones", label: "Avance de Colocaciones", allowed: [8, 3, 2, 1, 6, 10, 9, 13, 5] },
    ]
  },
  {
    title: "Prospectos",
    icon: ProspectsSolid,
    items: [
      { to: "/prospectos", label: "Data prospectos", allowed: [1, 2, 3, 4, 6, 8, 9, 10, 27] },
      { to: "/prospectos_tnp", label: "Prospectos TNP", allowed: [6, 8, 28] },
      { to: "/simulador_creditos", label: "Simulador de prestamos", allowed: [1, 2, 3, 4, 6, 8, 9, 10, 27] },
      { to: "/seguimiento-boleta-prospecto", label: "Seguimiento de boletas", allowed: [1, 3, 6, 8, 9, 23, 4, 27] },
      { to: "/restablecer_prospectos", label: "Restablecer prospectos", allowed: [6, 8, 23] },
    ]
  },
  {
    title: "Desembolsos",
    icon: FileChartBarSolid,
    items: [
      { to: "/avances", label: "Avances", allowed: [1, 2, 3, 4, 6, 8, 9, 10, 27] },
      { to: "/revision", label: "Reporte de desembolsos", allowed: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20, 26, 27] },
      { to: "/solicitudes_extra", label: "Reporte de solicitudes extra", allowed: [1, 2, 3, 4, 6, 8, 9, 10, 27] },
      { to: "/seguimiento-desembolsos", label: " Seguimiento", allowed: [8, 23, 1, 2, 6] },
    ]
  },
  {
    title: "Asignación de Metas",
    to: "/asignacion_metas",
    icon: FileCheckSolid,
    allowed: [1, 2, 3, 6, 8, 9, 10]
  },
  {
    title: "Usuarios",
    to: "/usuarios",
    icon: UserPlusSolid,
    allowed: [5, 8, 11, 22, 26]
  },
  {
    title: "Talento Humano",
    icon: UsersSolid,
    items: [
      { to: "/asistencias", label: "Control de Asistencias", allowed: [1, 5, 8, 9, 22, 26] },
      { to: "/gestion_salida", label: "Gestión de Salidas", allowed: [1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 13, 14, 19, 21, 22, 23, 24, 25, 26, 29, 30, 32] },
      { to: "/sueldos-planilla", label: "Sueldos Planilla", allowed: [5, 8, 22, 26] },
      { to: "/descuento-tardanza", label: "Descuentos Planilla", allowed: [5, 8, 9, 26, 22] },
      { to: "/pagos_planilla", label: "Gestión de Planilla", allowed: [8, 5, 22, 26, 9, 1] },
      // { to: "/administracion_cargo_pago", label: "Planilla de Administración", allowed: [8] },
      { to: "/rh_administracion", label: "Recibo por Honorarios de Administración", allowed: [5, 8, 9, 26, 22] },
      // { to: "/planilla_negocios", label: "Planilla de Negocios", allowed: [8] },
      { to: "/cargo_pago", label: "Recibo por Honorarios de Negocios", allowed: [1, 5, 8, 22, 26, 9] },
      { to: "/rh_practicantes", label: "Recibo por Honorarios de Practicantes", allowed: [1, 5, 8, 9, 11, 22, 26] },
      { to: "/planilla", label: "Comisiones de Negocios", allowed: [5, 8, 22, 26] },
      { to: "/capacitaciones", label: "Registro de Capacitaciones", allowed: [5, 8, 22, 26] },
      { to: "/personal_reclutamiento", label: "Reclutamiento de Personal", allowed: [8, 6, 1, 11, 12, 26, 9, 22, 5] },
      // { to: "/recibo_honorarios", label: "Recibo por honorarios", allowed: [8, 5, 18, 22] },
      // { to: "/comisiones-desembolsos", label: "Comisión Comercial", allowed: [8] },
      { to: "/induccion", label: "Registro de Inducción", allowed: [5, 8, 22, 26] },
      { to: "/practicantes", label: "Gestión de Practicantes", allowed: [5, 8, 22, 26] },
      { to: "/cesos", label: "Registro de Cesos", allowed: [5, 8, 22, 26] },
      { to: "/validacion-servicio", label: "Validación de servicio", allowed: [5, 8, 22, 26] },
      { to: "/renuncias", label: "Registro de Renuncias", allowed: [5, 8, 22, 26] },
      { to: "/registro_memorandum", label: "Registro de Memorandums", allowed: [1, 3, 5, 6, 8, 9, 11, 21, 22, 23, 24, 25, 26] },
      { to: "/contrato_colaborador", label: "Verificación de Contratos", allowed: [8, 26, 5, 22] },
    ]
  },
  {
    title: "Logística",
    icon: ArchiveSolid,
    items: [
      { to: "/inventario", label: "Inventario", allowed: [8, 10, 11, 12, 9, 26] },
    ]
  },
  {
    title: "Flujo de Caja",
    icon: CashSolid,
    items: [
      { to: "/caja_flujo_datos", label: "Conceptos", allowed: [8, 12, 26] },
      { to: "/caja-financiero-presupuesto", label: "Presupuesto", allowed: [8, 12, 1, 16, 9, 15, 26] },
      { to: "/caja_financiero_movimiento", label: "Movimiento", allowed: [8, 10, 12, 9, 26] },
      { to: "/caja_financiero_contabilidad", label: "Contabilidad", allowed: [8, 10, 12, 9, 26] },
      { to: "/caja_financiero_reporte", label: "Resumen", allowed: [8, 10, 12, 9, 26] },
    ]
  },
  {
    title: "Gestión de Viaticos",
    icon: GestionViaticosIcon,
    items: [
      { to: "/gestion_pasajes", label: "Gestión de pasajes", allowed: [8, 26] },
      { to: "/solicitud_viaticos", label: "Solicitud de Viáticos", allowed: [1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 13, 14, 21, 22, 23, 24, 25, 26] },
      { to: "/planilla_viaticos", label: "Planilla de Viáticos", allowed: [1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 13, 14, 21, 22, 23, 24, 25, 26] },
      { to: "/rendicion_viaticos", label: "Rendición de Viáticos", allowed: [1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 13, 14, 21, 22, 23, 24, 25, 26] },
    ]
  },
  {
    title: "Tesorería",
    icon: TesoreriaIcon,
    items: [
      { to: "/pago_detracciones", label: "Pago de detracciones", allowed: [8, 26] },
      { to: "/gestion_proveedores", label: "Gestión de proveedores", allowed: [8, 11, 12, 26] },
      { to: "/gestion_servicios_proveedor", label: "Gestión de servicios", allowed: [8, 11, 12, 26] },
      { to: "/pago_proveedores", label: "Pago de proveedores", allowed: [8, 26, 9] },
    ]
  },
  {
    title: "Finanzas",
    icon: CashSolid,
    items: [
      { to: "/finanzas-cobranzas", label: "Cobranzas", allowed: [8, 12, 26] },
      { to: "/proceso_requerimientos", label: "Proceso de requerimientos", allowed: [5, 8, 12, 19, 21, 24, 25, 26] },
    ]
  },
  {
    title: "Gestión de Actividades",
    to: "/tareas_gantt",
    icon: GanttSolid,
    allowed: [8, 5, 1, 6, 9, 10, 11, 12, 15, 21, 22, 3, 26, 14, 24, 25, 19]
  },
  {
    title: "Plan Operativo Institucional",
    to: "/control-poi",
    icon: ClipboardListSolid,
    allowed: [8, 5, 12, 1, 6, 10, 11, 21, 15, 9, 26]
  },
  {
    title: "Inducción Negocios",
    to: "/induccion_negocios",
    icon: InduccionSolid,
    allowed: [1, 2, 3, 4, 6, 8, 9, 23, 27]
  },
  // {
  //   title: "Firma Digital Planillero",
  //   to: "/firma_digital_convenios",
  //   icon: SignatureSolid,
  //   allowed: [8]
  // },
  {
    title: "Sistemas",
    icon: ComputerSolid,
    items: [
      { to: "/gestion_correo", label: "Gestion de correos", allowed: [8, 5, 22, 12, 24, 25, 26] },
      { to: "/gestion_externo_sistemas", label: "Gestión de trámite externo", allowed: [8, 1, 6, 10, 9, 24, 25, 26] },
      { to: "/gestion_servicio_sistemas", label: "Gestión de servicios", allowed: [8, 5, 1, 6, 9, 11, 12, 15, 21, 22, 24, 25, 26] },
      { to: "/sesiones_activas", label: "Sesiones activas", allowed: [8, 24, 25, 26] },
      { to: "/dispositivos_confianza", label: "Dispositivos de confianza", allowed: [8, 24, 25, 26] },
    ]
  },
];

const NavigationLinks = ({ perfilId, onLinkClick, isCollapsed, mode = "sidebar", itemsPerPage = 5, linkClassName }) => {
  const id = Number(perfilId);
  const location = useLocation();
  const [openGroups, setOpenGroups] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const filterAllowed = (items) => {
    return items.filter(item => item.allowed === "all" || item.allowed.includes(id));
  };

  const isGroupAllowed = (group) => {
    if (group.to) {
      return group.allowed === "all" || group.allowed.includes(id);
    }
    return filterAllowed(group.items).length > 0;
  };

  useEffect(() => {
    if (mode === "sidebar") {
      const currentPath = location.pathname;
      const groupToExpand = {};
      menuGroups.forEach(group => {
        if (group.items?.some(item => item.to === currentPath)) {
          groupToExpand[group.title] = true;
        }
      });
      setOpenGroups(prev => ({ ...prev, ...groupToExpand }));
    }
  }, [location, mode]);

  if (mode === "home") {
    const items = [];
    menuGroups.forEach(group => {
      if (isGroupAllowed(group)) {
        if (group.items) {
          const allowedSubItems = filterAllowed(group.items);
          if (allowedSubItems.length > 0) {
            items.push({ type: 'header', label: group.title, icon: group.icon });
            allowedSubItems.forEach(item => {
              items.push({ to: item.to, label: item.label, isSubItem: true });
            });
          }
        }
        else if (group.to) {
          items.push({ to: group.to, label: group.title, icon: group.icon, isSingle: true });
        }
      }
    });

    const totalPages = Math.ceil(items.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedItems = items.slice(startIndex, startIndex + itemsPerPage);

    return (
      <div className="home-nav-container">
        <div className="home-nav-list">
          {paginatedItems.map((item, index) => {
            if (item.type === 'header') {
              return (
                <div key={`header-${index}`} className="home-nav-header">
                  {item.icon && <item.icon className="w-5 h-5 me-2" />}
                  <span>{item.label}</span>
                </div>
              );
            }
            return (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={onLinkClick}
                className={({ isActive }) =>
                  `${linkClassName || "home-nav-link"} ${isActive ? "active" : ""} ${item.isSubItem ? "sub-item" : ""} ${item.isSingle ? "single-group" : ""}`
                }
              >
                {item.isSingle && item.icon && <item.icon className="w-5 h-5 me-2" />}
                {item.label}
              </NavLink>
            );
          })}
        </div>
        {totalPages > 1 && (
          <div className="home-pagination-arrows">
            <button
              onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
              className={`pagination-arrow ${currentPage === 1 ? "disabled" : ""}`}
              disabled={currentPage === 1}
            >
              <ChevronLeft size={20} />
            </button>
            <span className="pagination-info">{currentPage} / {totalPages}</span>
            <button
              onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
              className={`pagination-arrow ${currentPage === totalPages ? "disabled" : ""}`}
              disabled={currentPage === totalPages}
            >
              <ChevronRight size={20} />
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full scrollbar-none">
      <ul className="space-y-1">
        {menuGroups.map((group) => {
          if (!isGroupAllowed(group)) return null;

          if (group.to) {
            return (
              <li key={group.to}>
                <NavLink
                  to={group.to}
                  onClick={(e) => {
                    if (location.pathname === group.to) e.preventDefault();
                    if (onLinkClick) onLinkClick();
                  }}
                  className={({ isActive }) =>
                    `flex items-center px-3 py-2 rounded-base transition-all duration-200 group ${isActive
                      ? "bg-[#59667a] text-white"
                      : "text-white hover:bg-[#59667a]"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {group.icon && (
                        <group.icon
                          className={`w-6 h-6 transition-colors duration-200 ${isActive ? "text-white" : "text-[#c4c9d0] group-hover:text-white"
                            }`}
                        />
                      )}
                      {!isCollapsed && (
                        <span className="ms-3 whitespace-nowrap text-sm">
                          {group.title}
                        </span>
                      )}
                    </>
                  )}
                </NavLink>
              </li>
            );
          }

          const allowedItems = filterAllowed(group.items);
          const isExpanded = openGroups[group.title];
          const isAnyChildActive = allowedItems.some(item => location.pathname === item.to);

          return (
            <li key={group.title}>
              <button
                type="button"
                onClick={() => setOpenGroups(prev => ({ ...prev, [group.title]: !prev[group.title] }))}
                className={`flex items-center w-full px-3 py-2 text-sm transition-all duration-200 rounded-base group ${isAnyChildActive && !isExpanded ? "bg-[#59667a]/40 text-white" : "text-white hover:bg-[#59667a]"
                  }`}
              >
                <group.icon className={`w-6 h-6 transition-colors duration-200 ${isAnyChildActive || isExpanded ? "text-white" : "text-[#c4c9d0] group-hover:text-white"
                  }`} />
                {!isCollapsed && (
                  <>
                    <span className="flex-1 ms-3 text-left whitespace-nowrap">{group.title}</span>
                    <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''} ${isExpanded ? "text-white" : "text-[#c4c9d0] group-hover:text-white"
                      }`} />
                  </>
                )}
              </button>

              {!isCollapsed && (
                <ul className={`py-1 space-y-1 overflow-hidden transition-all duration-300 ${isExpanded ? 'max-h-[2000px]' : 'max-h-0'}`}>
                  {allowedItems.map((item) => (
                    <li key={item.to}>
                      <NavLink
                        to={item.to}
                        onClick={(e) => {
                          if (location.pathname === item.to) e.preventDefault();
                          if (onLinkClick) onLinkClick();
                        }}
                        className={({ isActive }) =>
                          `flex items-center w-full p-2 ps-12 text-sm transition-all duration-200 rounded-base ${isActive ? "bg-[#59667a] text-white" : "text-white hover:bg-[#59667a]"
                          }`
                        }
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default NavigationLinks;
